import { useState, useEffect } from 'react'

const Point = ( {
  config
} ) => {
  const [ color, setColor ] = useState( config.color )

  // color
  useEffect( () => {
    console.debug( 'update color', config.color )

    setColor( config.color )
  }, [ config.color ] )

  if ( ! config.point )
    return null

  return <div className="circle-marker">
    <label
      style={ {
        color: color || 'purple'
      } }
    >{ config.label }</label>

    <div
      className="point"
      style={ {
        background: color || 'purple'
      } }></div>
  </div>
}

export default Point
